import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, ElementRef, inject, Input, QueryList } from '@angular/core';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldComponent } from '../icon-field/icon-field.component';
import { InputHelpTextComponent } from '../input-help-text/input-help-text.component';

@Component({
  selector: 'osp-input-icon',
  standalone: true,
  imports: [
    InputIconModule,
    InputHelpTextComponent
],
  templateUrl: './input-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputIconComponent implements AfterContentInit {
  private iconField = inject(IconFieldComponent);
  private hostElemRef = inject(ElementRef);

  @ContentChildren('i', { descendants: true, read: ElementRef }) iconsContent!: QueryList<ElementRef>;

  @Input() styleClass?: string;
  @Input() helpText: string = '';

  ngAfterContentInit(): void {
    // Calculates amount of provided icons
    // and provides this info to IconFieldComponent in order to make corresponding padding for an input element
    const iconAmount = this.hostElemRef?.nativeElement.getElementsByClassName('p-input-icon')[0]?.children.length || 0;
    this.iconField.setIconAmount(iconAmount);
  }

}
